import AsyncPaginate from 'react-select-async-paginate';
import React from 'react';

export const LCReactAsyncPaginate = props =>
    <AsyncPaginate {...props} />;
